import React, { useState } from 'react';
import { motion } from 'framer-motion';

const Contact = () => {
  // --- CONFIGURATION ---
  // PASTE YOUR GOOGLE APPS SCRIPT WEB APP URL HERE
  const SCRIPT_URL = "https://script.google.com/macros/s/AKfycby4wVLDHnUt3T21b7cFCpaQ0oddKCCyJnk5Ulf83NWm-nL-x3DH3c6pWD1uB08-agOwkw/exec"; 

  // --- STATE MANAGEMENT ---
  const [formData, setFormData] = useState({
    Name: '',    
    Email: '',   
    Message: ''  
  });

  const [status, setStatus] = useState({
    submitting: false,
    submitted: false,
    error: null
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ ...status, submitting: true, error: null });

    const formBody = new FormData();
    formBody.append('Name', formData.Name);
    formBody.append('Email', formData.Email);
    formBody.append('Message', formData.Message);

    try {
      // FIX 1: Added mode: 'no-cors'. 
      // This prevents the browser from waiting for Google's complex redirects, 
      // making the "Sending" state finish much faster.
      await fetch(SCRIPT_URL, {
        method: 'POST',
        body: formBody,
        mode: 'no-cors' 
      });

      // Update state to success immediately
      setStatus({ submitting: false, submitted: true, error: null });
      setFormData({ Name: '', Email: '', Message: '' }); // Clear form

      // FIX 2: Automatically show the form again after 5 seconds
      setTimeout(() => {
        setStatus(prev => ({ ...prev, submitted: false }));
      }, 5000);

    } catch (error) {
      console.error("Error submitting form:", error);
      setStatus({ 
        submitting: false, 
        submitted: false, 
        error: "Something went wrong. Please try again later." 
      });
    }
  };

  return (
    <motion.div 
      className="section"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container">
        <motion.h1 
          className="text-red" 
          style={{ textAlign: 'center', marginBottom: '3rem' }}
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          Let’s Build the Future Together
        </motion.h1>
        
        <div className="contact-wrapper">
          <motion.div 
            className="contact-info"
            initial={{ x: -30, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            <h3>Get In Touch</h3>
            <p style={{ marginBottom: '1rem' }}>
              Your brand has a story. It has goals. It has a future. At ValuVant Solutions, we have the tools to bring that future into the present.
            </p>
            
            <div style={{ marginTop: '2rem' }}>
              <p><strong>Email:</strong> info@valuvant.com</p>
              <p><strong>Phone:</strong> +233545128068</p>
              <p><strong>Address:</strong> Accra, Ghana</p>
            </div>
          </motion.div>

          <motion.form 
            className="contact-form" 
            onSubmit={handleSubmit}
            initial={{ x: 30, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.4 }}
          >
            {/* Success Message */}
            {status.submitted ? (
              <motion.div 
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                style={{ 
                  background: '#d4edda', 
                  color: '#155724', 
                  padding: '2rem', 
                  borderRadius: '8px',
                  marginBottom: '1rem',
                  border: '1px solid #c3e6cb',
                  textAlign: 'center'
                }}
              >
                <h3>Message Sent!</h3>
                <p>Thank you! We have received your message.</p>
                <small>The form will reappear in a few seconds...</small>
              </motion.div>
            ) : (
              <>
                {status.error && (
                  <div style={{ color: 'red', marginBottom: '1rem' }}>{status.error}</div>
                )}
                
                <div className="form-group">
                  <label>Name</label>
                  <input 
                    type="text" 
                    name="Name" 
                    value={formData.Name} 
                    onChange={handleChange} 
                    placeholder="Your Name" 
                    required 
                  />
                </div>
                
                <div className="form-group">
                  <label>Email</label>
                  <input 
                    type="email" 
                    name="Email" 
                    value={formData.Email} 
                    onChange={handleChange} 
                    placeholder="Your Email" 
                    required 
                  />
                </div>
                
                <div className="form-group">
                  <label>Message</label>
                  <textarea 
                    rows="5" 
                    name="Message" 
                    value={formData.Message} 
                    onChange={handleChange} 
                    placeholder="How can we help you?" 
                    required
                  ></textarea>
                </div>
                
                <button 
                  type="submit" 
                  className="btn btn-primary"
                  disabled={status.submitting}
                  style={{ opacity: status.submitting ? 0.7 : 1, cursor: status.submitting ? 'not-allowed' : 'pointer' }}
                >
                  {status.submitting ? 'Sending...' : 'Send Message'}
                </button>
              </>
            )}
          </motion.form>
        </div>
      </div>
    </motion.div>
  );
};

export default Contact;